import React, { useContext, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../../assets/css/gcadmin/reservationpage/ReservationsPage.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

const FILTERS = ["All", "reserved", "issued", "returned"];
const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

/* ══════════════════════════════════════════
   View Modal
══════════════════════════════════════════ */
const ViewModal = ({ record, isTeacher, onClose }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 260); };

  const rows = isTeacher
    ? [
        ["Teacher Name",  record.lbteacher?.name  || "—"],
        ["Teacher Email", record.lbteacher?.email  || "—"],
        ["Book",          record.lbbook?.title     || "—"],
        ["Author",        record.lbbook?.author    || "—"],
        ["Status",        record.status            || "—"],
      ]
    : [
        ["Student Name",  record.lbstudent?.fullName || "—"],
        ["Roll No",       record.lbstudent?.roll_no  || "—"],
        ["Book",          record.lbbook?.title       || "—"],
        ["Author",        record.lbbook?.author      || "—"],
        ["Status",        record.status              || "—"],
      ];

  return (
    <div
      className={`gcAdmin-res-backdrop ${visible ? "gcAdmin-res-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcAdmin-res-modal ${visible ? "gcAdmin-res-modal--in" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="gcAdmin-res-modal-header">
          <h5 className="gcAdmin-res-modal-title">Reservation Details</h5>
          <button className="gcAdmin-res-modal-close" onClick={handleClose}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <div className="gcAdmin-res-modal-body">
          {rows.map(([label, value]) => (
            <div className="gcAdmin-res-detail-row" key={label}>
              <span className="gcAdmin-res-detail-label">{label}</span>
              <span className={`gcAdmin-res-detail-value ${
                label === "Status" ? `gcAdmin-res-detail-status gcAdmin-status--${record.status?.toLowerCase()}` : ""
              }`}>
                {value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Status Badge
══════════════════════════════════════════ */
const StatusBadge = ({ status }) => (
  <span className={`gcAdmin-res-badge gcAdmin-res-badge--${status?.toLowerCase()}`}>
    {status}
  </span>
);

/* ══════════════════════════════════════════
   Reusable Reservation Table
   (ab records already parent se filtered + paginated aa rahe hain)
══════════════════════════════════════════ */
const ReservationTable = ({ records, isTeacher, rowVisible, loadingId, onView, onApprove, onReject }) => {
  const tableClass = isTeacher ? "gcAdmin-res-table gcAdmin-res-table--teacher" : "gcAdmin-res-table gcAdmin-res-table--student";

  return (
    <div className="gcAdmin-res-table-wrap">
      <table className={tableClass}>
        <thead>
          <tr>
            <th className="gcAdmin-res-th">{isTeacher ? "Teacher" : "Student"}</th>
            <th className="gcAdmin-res-th">Book</th>
            <th className="gcAdmin-res-th">Status</th>
            <th className="gcAdmin-res-th">Actions</th>
          </tr>
        </thead>
        <tbody>
          {records?.map((record, i) => (
            <tr
              key={record.id}
              className={`gcAdmin-res-tr ${rowVisible[i] ? "gcAdmin-res-tr--visible" : ""}`}
              style={{ transitionDelay: `${i * 0.05}s` }}
            >
              {/* Person */}
              <td className="gcAdmin-res-td">
                {isTeacher ? (
                  <>
                    <div className="gcAdmin-res-person-name">{record.lbteacher?.name || "—"}</div>
                    <div className="gcAdmin-res-person-sub">{record.lbteacher?.email || "—"}</div>
                  </>
                ) : (
                  <>
                    <div className="gcAdmin-res-person-name">{record.lbstudent?.fullName || "—"}</div>
                    <div className="gcAdmin-res-person-sub">{record.lbstudent?.roll_no || "—"}</div>
                  </>
                )}
              </td>

              {/* Book */}
              <td className="gcAdmin-res-td">
                <div className="gcAdmin-res-book-title">{record.lbbook?.title || "—"}</div>
                <div className="gcAdmin-res-person-sub">{record.lbbook?.author || "—"}</div>
              </td>

              {/* Status */}
              <td className="gcAdmin-res-td">
                <StatusBadge status={record.status} />
              </td>

              {/* Actions */}
              <td className="gcAdmin-res-td gcAdmin-res-td--actions">
                <div className="gcAdmin-res-actions">

                  {/* View */}
                  <button
                    className="gcAdmin-res-btn gcAdmin-res-btn--view"
                    onClick={() => onView(record)}
                    title="View"
                    disabled={loadingId === record.id}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12S5 4 12 4s11 8 11 8-4 8-11 8S1 12 1 12z"
                        stroke="currentColor" strokeWidth="1.8"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
                    </svg>
                  </button>

                  {/* Approve & Reject — only for reserved */}
                  {record.status === "reserved" && (
                    <>
                      <button
                        className="gcAdmin-res-btn gcAdmin-res-btn--approve"
                        onClick={() => onApprove(record)}
                        disabled={loadingId === record.id}
                        title="Approve"
                      >
                        {loadingId === record.id ? (
                          <span className="gcAdmin-res-btn-spinner" />
                        ) : (
                          <>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M20 6L9 17l-5-5" stroke="currentColor"
                                strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Approve
                          </>
                        )}
                      </button>

                      <button
                        className="gcAdmin-res-btn gcAdmin-res-btn--reject"
                        onClick={() => onReject(record)}
                        disabled={loadingId === record.id}
                        title="Reject"
                      >
                        {loadingId === record.id ? (
                          <span className="gcAdmin-res-btn-spinner" />
                        ) : (
                          <>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor"
                                strokeWidth="2.2" strokeLinecap="round"/>
                            </svg>
                            Reject
                          </>
                        )}
                      </button>
                    </>
                  )}

                </div>
              </td>
            </tr>
          ))}

          {records?.length === 0 && (
            <tr>
              <td colSpan={4} className="gcAdmin-res-td gcAdmin-res-td--empty">
                No reservations found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

/* ══════════════════════════════════════════
   Main Page
══════════════════════════════════════════ */
const ReservationsPage = () => {
  const [activeTab,      setActiveTab]      = useState("students"); // "students" | "teachers"
  const [studentRecords, setStudentRecords] = useState([]);
  const [teacherRecords, setTeacherRecords] = useState([]);
  const [filter,         setFilter]         = useState("All");
  const [viewRecord,     setViewRecord]     = useState(null);
  const [viewIsTeacher,  setViewIsTeacher]  = useState(false);
  const [visible,        setVisible]        = useState(false);
  const [sRowVisible,    setSRowVisible]    = useState([]);
  const [tRowVisible,    setTRowVisible]    = useState([]);
  const [loadingId,      setLoadingId]      = useState(null);
  const [loading,        setLoading]        = useState(false); // initial API fetch loading
  const [sCurrentPage,   setSCurrentPage]   = useState(1);      // students pagination
  const [tCurrentPage,   setTCurrentPage]   = useState(1);      // teachers pagination

  // ── Tab switch ya pagination change hone par sirf currently
  //    active tab ke current page (10 records) ki loading dikhane ke liye ──
  const [viewLoading, setViewLoading] = useState(false);
  const isFirstRender = useRef(true);

  const { baseUrl, authToken } = useContext(AppContext);

  /* ── Fetch ── */
  const fetchAllBookings = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("status", "reserved");
    axios
      .post(`${baseUrl}/admin/bookings/fetchAllBookings`, formData,
        { headers: { "Authorization": `Bearer ${authToken}` } }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          const all = res.data.bookings;
          setStudentRecords(all.filter(r => r.lbstudent_id && !r.lbteacher_id));
          setTeacherRecords(all.filter(r => r.lbteacher_id && !r.lbstudent_id));
        }
      })
      .catch((err) => { setLoading(false); console.log(err); });
  };

  useEffect(() => { fetchAllBookings(); }, []);
  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  /* ── Filtered lists (per tab) ── */
  const filteredStudentRecords = studentRecords.filter(r => filter === "All" || r.status === filter);
  const filteredTeacherRecords = teacherRecords.filter(r => filter === "All" || r.status === filter);

  /* ── Paginated slices (jo table ko jayengi) ── */
  const paginatedStudentRecords = filteredStudentRecords.slice(
    (sCurrentPage - 1) * ITEMS_PER_PAGE,
    sCurrentPage * ITEMS_PER_PAGE
  );
  const paginatedTeacherRecords = filteredTeacherRecords.slice(
    (tCurrentPage - 1) * ITEMS_PER_PAGE,
    tCurrentPage * ITEMS_PER_PAGE
  );

  /* ── Filter change hone par dono pages 1 pe reset ── */
  useEffect(() => {
    setSCurrentPage(1);
    setTCurrentPage(1);
    // eslint-disable-next-line
  }, [filter]);

  /* ── Row animations (ab paginated data ke hisaab se) ── */
  useEffect(() => {
    setSRowVisible([]);
    paginatedStudentRecords.forEach((_, i) => {
      setTimeout(() => setSRowVisible(prev => { const n = [...prev]; n[i] = true; return n; }), i * 60);
    });
    // eslint-disable-next-line
  }, [filter, studentRecords, activeTab, sCurrentPage]);

  useEffect(() => {
    setTRowVisible([]);
    paginatedTeacherRecords.forEach((_, i) => {
      setTimeout(() => setTRowVisible(prev => { const n = [...prev]; n[i] = true; return n; }), i * 60);
    });
    // eslint-disable-next-line
  }, [filter, teacherRecords, activeTab, tCurrentPage]);

  /* ── Sirf jis tab (student/teacher) ka table abhi dikh raha hai
     usi ki, aur sirf current page ke (max 10) records ki loading dikhayein:
     - Jab tab switch ho (students <-> teachers)
     - Jab filter change ho
     - Jab us tab ke andar pagination se dusre page par jayen
     Doosre (chhupe hue) tab ki state change ho tab bhi kuch farak nahi
     padta kyunke wo table render hi nahi ho raha. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [activeTab, filter, sCurrentPage, tCurrentPage]);

  /* ── Approve ── */
  const handleApprove = (record) => {
    const name = record.lbstudent?.fullName || record.lbteacher?.name || "—";
    Swal.fire({
      title: "Approve Reservation?",
      html: `Approve <strong>"${record.lbbook?.title}"</strong> for
             <strong>${name}</strong>?<br/>
             <small>Book will be marked as <b>Issued</b> for 14 days.</small>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#1a5f7a",
    }).then((result) => {
      if (!result.isConfirmed) return;
      setLoadingId(record.id);
      const formData = new FormData();
      formData.append("booking_id", record.id);
      axios
        .post(`${baseUrl}/admin/bookings/approveReservation`, formData,
          { headers: { "Authorization": `Bearer ${authToken}` } })
        .then((res) => {
          setLoadingId(null);
          if (res.data.success === true) {
            Swal.fire({ icon: "success", title: "Approved!", text: "Book has been issued successfully.", confirmButtonColor: "#1a5f7a" });
            const isTeacherRecord = !!record.lbteacher_id;
            if (isTeacherRecord) setTeacherRecords(prev => prev.filter(r => r.id !== record.id));
            else                 setStudentRecords(prev => prev.filter(r => r.id !== record.id));
          } else {
            Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Something went wrong." });
          }
        })
        .catch((err) => { setLoadingId(null); console.log(err); Swal.fire({ icon: "error", title: "Error", text: "Something went wrong." }); });
    });
  };

  /* ── Reject ── */
  const handleReject = (record) => {
    const name = record.lbstudent?.fullName || record.lbteacher?.name || "—";
    Swal.fire({
      title: "Reject Reservation?",
      html: `Reject <strong>"${record.lbbook?.title}"</strong> request by
             <strong>${name}</strong>?<br/>
             <small>This reservation will be permanently deleted.</small>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d63031",
    }).then((result) => {
      if (!result.isConfirmed) return;
      setLoadingId(record.id);
      const formData = new FormData();
      formData.append("booking_id", record.id);
      axios
        .post(`${baseUrl}/admin/bookings/rejectReservation`, formData,
          { headers: { "Authorization": `Bearer ${authToken}` } }
        )
        .then((res) => {
          setLoadingId(null);
          if (res.data.success === true) {
            Swal.fire({ icon: "success", title: "Rejected!", text: "Reservation has been deleted.", confirmButtonColor: "#1a5f7a" });
            const isTeacherRecord = !!record.lbteacher_id;
            if (isTeacherRecord) setTeacherRecords(prev => prev.filter(r => r.id !== record.id));
            else                 setStudentRecords(prev => prev.filter(r => r.id !== record.id));
          } else {
            Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Something went wrong." });
          }
        })
        .catch((err) => { setLoadingId(null); console.log(err); Swal.fire({ icon: "error", title: "Error", text: "Something went wrong." }); });
    });
  };

  const isStudentsTab = activeTab === "students";
  const switchTab = (tab) => {
    setActiveTab(tab);
    setFilter("All");
    setSCurrentPage(1);
    setTCurrentPage(1);
  };

  /* ── isApiLoading: pehli baar poora data fetch ho raha hai
     viewLoading: tab switch / filter / pagination ki chhoti si (400ms)
     visual loading, sirf currently active tab ke current page ke liye ── */
  const showLoader = loading || viewLoading;

  return (
    <div className={`gcAdmin-res-page ${visible ? "gcAdmin-res-visible" : ""}`}>
      <Container fluid className="gcAdmin-res-container">

        {/* ── Header ── */}
        <div className="gcAdmin-res-header">
          <h2 className="gcAdmin-res-title">Manage Reservations</h2>
          <div className="gcAdmin-res-filter-wrap">
            <select
              className="gcAdmin-res-filter"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              {FILTERS.map((f) => (
                <option key={f} value={f}>
                  {f === "All" ? "All" : f.charAt(0).toUpperCase() + f.slice(1)}
                </option>
              ))}
            </select>
            <svg className="gcAdmin-res-filter-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* ── Tabs ── */}
        <div className="gcAdmin-res-tabs">
          <button
            className={`gcAdmin-res-tab ${isStudentsTab ? "gcAdmin-res-tab--active" : ""}`}
            onClick={() => switchTab("students")}
          >
            Students
            <span className="gcAdmin-res-tab-count">{studentRecords.length}</span>
          </button>
          <button
            className={`gcAdmin-res-tab ${!isStudentsTab ? "gcAdmin-res-tab--active" : ""}`}
            onClick={() => switchTab("teachers")}
          >
            Teachers
            <span className="gcAdmin-res-tab-count">{teacherRecords.length}</span>
          </button>
        </div>

        {/* ── Table + Pagination ── */}
        {showLoader ? (
          <Loader
            message={loading
              ? "Reservations loading, please wait..."
              : `${isStudentsTab ? "Student" : "Teacher"} reservations loading...`}
          />
        ) : isStudentsTab ? (
          <>
            <ReservationTable
              records={paginatedStudentRecords}
              isTeacher={false}
              rowVisible={sRowVisible}
              loadingId={loadingId}
              onView={(r) => { setViewRecord(r); setViewIsTeacher(false); }}
              onApprove={handleApprove}
              onReject={handleReject}
            />
            <Pagination
              currentPage={sCurrentPage}
              totalItems={filteredStudentRecords.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setSCurrentPage}
            />
          </>
        ) : (
          <>
            <ReservationTable
              records={paginatedTeacherRecords}
              isTeacher={true}
              rowVisible={tRowVisible}
              loadingId={loadingId}
              onView={(r) => { setViewRecord(r); setViewIsTeacher(true); }}
              onApprove={handleApprove}
              onReject={handleReject}
            />
            <Pagination
              currentPage={tCurrentPage}
              totalItems={filteredTeacherRecords.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setTCurrentPage}
            />
          </>
        )}

      </Container>

      {/* Modal */}
      {viewRecord && (
        <ViewModal
          record={viewRecord}
          isTeacher={viewIsTeacher}
          onClose={() => setViewRecord(null)}
        />
      )}
    </div>
  );
};

export default ReservationsPage;